function snq(callback, defaultValue) {
    try {
        var result = callback();
        return typeof result === 'undefined' ? defaultValue : result;
    }
    catch (err) {
        if (err instanceof TypeError) {
            return defaultValue;
        }
        throw err;
    }
}

export default snq;
//# sourceMappingURL=snq.es5.js.map
